/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov, Slobodan Djordjevic
 */
import React from "react"
import { Icon, trackEvent, useToken, VideoControlButton } from "trux"
import { traceIdMomentUrl } from "../util/links"
import { useGetMomentCollectionInfoQuery } from "../generated/graphql"

const TraceIDButton = ({
    saveUrl,
    history,
    iconColor,
    event,
    acl,
    trkAction,
    afterOnClick,
}) => {
    const token = useToken("TraceIDButton")
    // eslint-disable-next-line eqeqeq
    const tokenReady = token != null

    const { data: momentCollectionData } = useGetMomentCollectionInfoQuery({
        variables: {
            token: token,
            game_clip_id: event?.game_clip_id,
            user_id: token?.user_id,
        },
        skip: !tokenReady || !event?.game_clip_id,
    })

    let isMomentAdded = momentCollectionData?.momentCollectionInfo?.length

    const onClick = (e) => {
        trackEvent({
            context: "Trace iD Button",
            action: "Add to Trace iD Pressed",
            element: e.currentTarget,
        })
        if (isMomentAdded) {
            let momentInfo = momentCollectionData.momentCollectionInfo[0]
            window.location.href = traceIdMomentUrl(
                momentInfo.playlist_hash_key,
                momentInfo.collection_hash_key,
                momentInfo.user_playlist_clip_id,
                acl
            )
        } else {
            if (saveUrl.startsWith("http")) {
                window.location.href = saveUrl
            } else {
                history.push(saveUrl)
            }
        }
        if (typeof afterOnClick === "function") {
            afterOnClick(e)
        }
    }

    return (
        <VideoControlButton
            trkAction={trkAction}
            onClick={onClick}
            icon={
                isMomentAdded ? Icon.Type.TraceIDFilled : Icon.Type.TraceIDEmpty
            }
            iconColor={iconColor}
            iconSize="24"
            title={(isMomentAdded ? "Go " : "Save ") + "to Trace iD"}
        />
    )
}

export default TraceIDButton
